import { ErrorReporter } from '@wix/editor-error-reporter';

import type { EditorAPI } from '#packages/editorAPI';
import type { Scope } from '#packages/sections';

type BeforePageNavigateHook = Parameters<
  GetFieldType<EditorAPI, 'pages.hooks.beforePageNavigate.tap'>
>[0];

const tryEnforceSectionsOnPage = async (scope: Scope, pageId: string) => {
  const { editorAPI } = scope;
  try {
    if (!pageId) return;
    const pageRef = editorAPI.pages.getReference(pageId);
    if (!pageRef) return;
    await scope.enforceSectionOnPageService.run(pageRef);
  } catch (error: MaybeError) {
    error.name = `[SectionsBeforeNavigateEnforcement]: ${error.name}`;
    ErrorReporter.captureException(error);
  }
};

export const createBeforePageNavigateEnforcement = (
  scope: Scope,
): BeforePageNavigateHook => {
  const hook: BeforePageNavigateHook = async ({ pageId }) => {
    await tryEnforceSectionsOnPage(scope, pageId);
  };

  return hook;
};
